module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-header clearfix"
  }, [_vm._m(0), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/header-logo-white-xd.png")
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-10d5fa62", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10d5fa62","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/components/c-header/index.vue
// module id = 1183
// module chunks = 2